import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import api from "@/lib/api";

export default function WhatsAppButton() {
  const [number, setNumber] = useState("");

  useEffect(() => {
    api.get("/site-config").then(({ data }) => {
      setNumber(data.whatsapp_number || "");
    }).catch(() => {});
  }, []);

  if (!number) return null;
  const href = `https://wa.me/${number.replace(/[^0-9]/g, "")}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 px-4 py-3 rounded-full bg-[#25D366] hover:bg-[#20b656] text-white font-semibold shadow-xl shadow-emerald-500/40 transition-colors"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline">WhatsApp</span>
    </a>
  );
}
